import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Table,
  Modal,
  Select,
  Form,
  DatePicker,
  Space,
  message,
} from "antd";
import { PlusOutlined, HistoryOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import { addBatch, getBatch, updateBatch } from "@root/common/service";
import { store } from "@root/store";
import moment from "moment";
import "../_style.scss";

const { Option } = Select;
interface DataType {
  id: number;
  key: number;
  year: string | number;
  batchNumber: number;
  beginTime: string;
  // endTime: any;
  endTime: string | Date;
  sysYesNo: number;
  createTime: string;
}

function SetBatch(props: any) {
  const [form2] = Form.useForm();

  const columns: ColumnsType<DataType> = [
    {
      title: "年度",
      dataIndex: "year",
      key: "year",
      align: "center",
    },
    {
      title: "批次",
      dataIndex: "batchNumber",
      key: "batchNumber",
      align: "center",
    },
    {
      title: "调整开始日期",
      dataIndex: "beginTime",
      key: "beginTime",
      align: "center",
    },
    {
      title: "调整截止日期",
      dataIndex: "endTime",
      key: "endTime",
      align: "center",
    },
    {
      title: "状态",
      dataIndex: "sysYesNo",
      key: "sysYesNo",
      align: "center",
      render: (_, a) => (
        <>
          {(() => {
            if (
              new Date(moment().format("YYYY-MM-DD")).valueOf() <
              new Date(a?.beginTime).valueOf()
            ) {
              return <span>未开始</span>;
            } else if (
              new Date(moment().format("YYYY-MM-DD")).valueOf() >
              new Date(a?.endTime).valueOf()
            ) {
              return <span>已结束</span>;
            } else {
              return <span>进行中</span>;
            }
          })()}
        </>
      ),
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      align: "center",
      render: (_, e) =>
        !!e && (
          <Space size="middle">
            <Button
              style={{ padding: "0" }}
              onClick={() => setTime(e)}
              type="link"
            >
              设置时间
            </Button>
            <Button
              style={{ padding: "0" }}
              onClick={() => setProvince(e)}
              type="link"
            >
              按省设置
            </Button>
          </Space>
        ),
    },
  ];
  const columnsHis: ColumnsType<DataType> = [
    {
      title: "年度",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "批次",
      dataIndex: "batchNumber",
      key: "batchNumber",
    },
    {
      title: "调整开始日期",
      dataIndex: "beginTime",
      key: "beginTime",
    },
    {
      title: "调整截止日期",
      dataIndex: "endTime",
      key: "endTime",
    },
    {
      title: "状态",
      dataIndex: "sysYesNo",
      key: "sysYesNo",
      render: (_, a) => (
        <>
          {(() => {
            if (a?.sysYesNo === 1) {
              return <span>进行中</span>;
            } else if (a?.sysYesNo === 0) {
              return <span>已结束</span>;
            }
          })()}
        </>
      ),
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      render: (_, e) => (
        <Space size="middle">
          <Button
            disabled
            style={{ padding: "0" }}
            onClick={() => setTime(e)}
            type="link"
          >
            设置时间
          </Button>
          <Button
            disabled
            style={{ padding: "0" }}
            onClick={() => setProvince(e)}
            type="link"
          >
            按省设置
          </Button>
        </Space>
      ),
    },
  ];

  const [dataSourceNow, setDataSourceNow] = useState<DataType[]>();
  const [dataSourceHis, setDataSourceHis] = useState<DataType[]>();
  const [isAddVisible, setIsAddVisible] = useState(false);
  const [isHisVisible, setIsHisVisible] = useState(false);
  const [isSetTimeVisible, setIsSetTimeVisible] = useState(false);
  const [timeItem, setTimeItem] = useState({
    beginTime: "",
    endTime: "",
    id: "",
  });
  const [nowYear, setNowYear] = useState<number>();
  const [batch, setBatch] = useState<number>();

  const getAll = async () => {
    const { rows } = await getBatch();
    const arr: any = [];
    rows.forEach((e: any) => {
      e.key = e.id;
      if (e.sysYesNo === 1) {
        setDataSourceNow([rows[0]]);
      } else {
        arr.push(e);
      }
    });
    console.log(rows);
    setDataSourceHis(arr);
    if (rows.length > 0) {
      const batch = rows[0].batchNumber + 1;
      setBatch(batch);
    } else {
      setBatch(1);
    }
  };

  useEffect(() => {
    getAll();
    console.log(store.getState());
    const date = new Date();
    setNowYear(date.getFullYear());
  }, []);
  const setTime = useCallback(
    (e: any) => {
      console.log("setTime", e);
      setTimeItem(e);
      form2.setFieldsValue({
        id: e.id,
        startDate: moment(e.beginTime, "YYYY-MM-DD"),
        endDate: moment(e.endTime, "YYYY-MM-DD"),
      });
      setIsSetTimeVisible(true);
    },
    [form2]
  );
  const setTimeCancel = useCallback((e: any) => {
    setIsSetTimeVisible(false);
  }, []);
  const setProvince = useCallback(
    (e: any) => {
      console.log("setProvince", e);
      props.setKey("2");
    },
    [props]
  );
  const addBatchModel = useCallback(() => {
    console.log("新增批次弹出框打开");
    setIsAddVisible(true);
  }, []);
  const addCancel = useCallback(() => {
    console.log("新增批次弹出框关闭");
    setIsAddVisible(false);
  }, []);
  const handleChange = useCallback((e: any, a: any) => {
    console.log("选择结果", e, a);
  }, []);
  const onFinish = useCallback((e: any) => {
    console.log("onFinish", e);
    const addOne = async (e: any) => {
      const { code, msg } = await addBatch({
        year: e.year,
        batchNumber: e.batch,
        beginTime: moment(e.startTime).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment(e.endTime).format("YYYY-MM-DD HH:mm:ss"),
      });
      if (code === 200) {
        message.success("新增成功");
        getAll();
      } else {
        message.error(`新增失败,${msg}`);
      }
    };
    addOne(e);
    setIsAddVisible(false);
  }, []);
  const setTimeFinish = useCallback((e: any) => {
    console.log("setTimeFinish", e);
    const setOne = async (e: any) => {
      const { code, msg } = await updateBatch({
        id: e.id,
        beginTime: moment(e.startDate).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment(e.endDate).format("YYYY-MM-DD HH:mm:ss"),
      });
      if (code === 200) {
        message.success("更新成功");
        getAll();
      } else {
        message.error(`更新失败,${msg}`);
      }
    };
    setOne(e);
    setIsSetTimeVisible(false);
  }, []);
  const onFinishFailed = useCallback(() => {
    console.log("onFinishFailed验证未通过");
  }, []);
  const historyBatch = useCallback(() => {
    console.log("historyBatch");
    setIsHisVisible(true);
  }, []);
  const hisCancel = useCallback(() => {
    console.log("hisCancel");
    setIsHisVisible(false);
  }, []);
  return (
    <>
      <div className="topBtn">
        <Button type="primary" onClick={addBatchModel}>
          <PlusOutlined />
          新增批次
        </Button>
        <Button type="primary" onClick={historyBatch} className="his">
          <HistoryOutlined />
          历史批次
        </Button>
      </div>
      <div className="boxTable">
        <Table
          pagination={false}
          size="middle"
          dataSource={dataSourceNow}
          columns={columns}
          bordered
        />
      </div>
      <Modal
        title="新增批次"
        visible={isAddVisible}
        onCancel={addCancel}
        footer={[]}
      >
        <Form
          name="addBatch"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="年度"
            name="year"
            rules={[{ required: true, message: "年度不可为空，请正确选择!" }]}
          >
            <Select
              placeholder="请选择年度"
              onChange={handleChange}
              allowClear
              // defaultValue={nowYear}
            >
              <Option value={nowYear}>{nowYear}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="批次"
            name="batch"
            rules={[{ required: true, message: "批次不可为空，请正确选择!" }]}
          >
            <Select
              placeholder="请选择批次"
              onChange={handleChange}
              allowClear
              // defaultValue={batch}
            >
              <Option value={batch}>{batch}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="调整开始时间"
            name="startTime"
            rules={[
              { required: true, message: "开始时间不可为空，请正确选择!" },
            ]}
          >
            <DatePicker onChange={handleChange} />
          </Form.Item>

          <Form.Item
            label="调整结束时间"
            name="endTime"
            rules={[
              { required: true, message: "结束时间不可为空，请正确选择!" },
            ]}
          >
            <DatePicker onChange={handleChange} />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button style={{ marginRight: "15px" }} onClick={addCancel}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="历史批次"
        visible={isHisVisible}
        onCancel={hisCancel}
        footer=""
        width="1000px"
      >
        <Table dataSource={dataSourceHis} columns={columnsHis} bordered />
      </Modal>
      <Modal
        title="设置时间"
        visible={isSetTimeVisible}
        onCancel={setTimeCancel}
        footer={[]}
        width="650px"
      >
        <Form
          name="provinceSet"
          onFinish={setTimeFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ marginTop: "15px" }}
          layout="inline"
          initialValues={{
            id: timeItem.id,
            startDate: moment(timeItem.beginTime, "YYYY-MM-DD"),
            endDate: moment(timeItem.endTime, "YYYY-MM-DD"),
          }}
          form={form2}
        >
          <Form.Item label="id" name="id" style={{ display: "none" }}>
            {timeItem.id}
          </Form.Item>
          <Form.Item
            label="开始日期"
            name="startDate"
            rules={[
              { required: true, message: "开始时间不可为空，请正确选择!" },
            ]}
          >
            <DatePicker disabled onChange={handleChange} />
          </Form.Item>

          <Form.Item
            label="结束日期"
            name="endDate"
            rules={[
              { required: true, message: "结束时间不可为空，请正确选择!" },
            ]}
          >
            <DatePicker onChange={handleChange} />
          </Form.Item>

          <Form.Item
            style={{
              display: "flex",
              marginTop: "15px",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button onClick={setTimeCancel} style={{ marginRight: "15px" }}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default SetBatch;
